import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment.development';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorHandleService } from '../services/error-handle.service';
import { DashboardGolfMemberResponse } from '../models/dashboard';

export interface ChartData {
  category: string;
  value: number;
}

@Injectable({
  providedIn: 'root'
})
export class PieChartService {
  private apiUrl = `${environment.APIDEV}`;


  constructor(
    private http: HttpClient,
    private errorHandle: ErrorHandleService
  ) { }


  // Method untuk mengambil data chart dari API
  getChartData(startDate?: string, endDate?: string): Observable<ChartData[]> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<DashboardGolfMemberResponse>(`${this.apiUrl}overview/golf_membership`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      map(response => {
        // Transform response chart data ke format ChartData
        return response.data.chart.map(item => ({
          category: item.label,
          value: item.value
        }));
      }),
      catchError(this.errorHandle.errorHandl)
    );
  }

  calculateTotal(data: ChartData[]): number {
    return data.reduce((sum, item) => sum + item.value, 0);
  }

  getDashboardGolfMember(
    startDate?: string,
    endDate?: string
  ): Observable<DashboardGolfMemberResponse> {

    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<DashboardGolfMemberResponse>(`${this.apiUrl}overview/golf_membership`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  // Optional: Method tambahan untuk mendapatkan kategori yang tersedia
  getAvailableCategories(startDate?: string, endDate?: string): Observable<string[]> {
    return this.getChartData(startDate, endDate).pipe(
      map(data => data.map(item => item.category))
    );
  }

  // Optional: Method untuk mendapatkan data berdasarkan kategori tertentu
  getDataByCategory(category: string, startDate?: string, endDate?: string): Observable<ChartData | undefined> {
    return this.getChartData(startDate, endDate).pipe(
      map(data => data.find(item => item.category.toLowerCase() === category.toLowerCase()))
    );
  }
}
